// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seller-directory":"UQboAWg_sTAmetk1z3wS","global-regions":"_4p2Ln4fpeIMlGPg4Ikr"};